module.exports = __webpack_public_path__ + "static/img/egg_r_13.b00f471.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/r/egg_r_13.png
// module id = 6hHG
// module chunks = 1